/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';
import kitconceptvoltoDsgvoBanner from '@kitconcept/volto-dsgvo-banner';
import voltoCsj from 'volto-csj';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.0.4","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/app/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/app/core/packages/volto-slate/package.json","basePath":"/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"@kitconcept/volto-dsgvo-banner","version":"4.0.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/node_modules/.pnpm/@kitconcept+volto-dsgvo-banner@4.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@kitconcept/volto-dsgvo-banner/src","hasServerConfig":false,"packageJson":"/app/node_modules/.pnpm/@kitconcept+volto-dsgvo-banner@4.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@kitconcept/volto-dsgvo-banner/package.json","basePath":"/app/node_modules/.pnpm/@kitconcept+volto-dsgvo-banner@4.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@kitconcept/volto-dsgvo-banner","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"@kitconcept/volto-dsgvo-banner/*":["./src/*"]}],"addons":[]},{"name":"volto-csj","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/volto-csj/src","hasServerConfig":false,"packageJson":"/app/packages/volto-csj/package.json","basePath":"/app/packages/volto-csj","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-csj/*":["./src/*"]}],"addons":[],"theme":"volto-csj","razzleExtender":"/app/packages/volto-csj/razzle.extend.js"}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, kitconceptvoltoDsgvoBanner, voltoCsj];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
